"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var _immutable = _interopRequireDefault(require("immutable"));

var _unescapedText = _interopRequireDefault(require("I18n/utils/unescapedText"));

var _LanguageSelect = _interopRequireDefault(require("ui-addon-i18n/components/LanguageSelect"));

// TODO use core constant
var validLanguages = ['af', 'sq', 'ar', 'hy', 'eu', 'be', 'bg', 'ca', 'zh', 'hr', 'cs', 'da', 'nl', 'en', 'et', 'fo', 'fa', 'fi', 'fr', 'gl', 'ka', 'de', 'el', 'gu', 'he', 'hi', 'hu', 'is', 'id', 'ga', 'it', 'ja', 'kn', 'kk', 'kok', 'ko', 'ky', 'lv', 'lt', 'mk', 'ms', 'mt', 'mr', 'mn', 'my', 'no', 'nb', 'pl', 'pt', 'pa', 'ro', 'ru', 'sa', 'sr', 'sk', 'sl', 'es', 'sw', 'sv', 'sy', 'ta', 'tt', 'te', 'th', 'tr', 'uk', 'ur', 'vi'];

var SupportedLanguagesSelect = function SupportedLanguagesSelect(_ref) {
  var onChange = _ref.onChange,
      value = _ref.value;
  var handleChange = (0, _react.useCallback)(function (_ref2) {
    var selectValue = _ref2.target.value;
    onChange(_immutable.default.Set(selectValue));
  }, [onChange]);
  return _react.default.createElement(_LanguageSelect.default, {
    clearable: true,
    multi: true,
    onChange: handleChange,
    placeholder: (0, _unescapedText.default)('appMarketplace.storefront.filters.supportedLanguages.selectPlaceholder'),
    validLanguages: validLanguages,
    value: value.toArray()
  });
};

SupportedLanguagesSelect.propTypes = {
  onChange: _propTypes.default.func.isRequired,
  value: _reactImmutableProptypes.default.iterableOf(_propTypes.default.oneOf(validLanguages)).isRequired
};
var _default = SupportedLanguagesSelect;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/storefront/sidebar/filters/SupportedLanguagesSelect.js
// module id = 731
// module chunks = 209 210 211 212